import { Theme } from '@logto/schemas';
import classNames from 'classnames';

import IconButton from '@/shared/components/IconButton';

import Moon from '../../assets/icons/moon.svg?react';
import Sun from '../../assets/icons/sun.svg?react';

import styles from './index.module.scss';

type Props = {
  readonly theme: Theme;
  readonly onToggle: (theme: Theme) => void;
  readonly className?: string;
};

const ThemeToggleButton = ({ theme, onToggle, className }: Props) => {
  const isDark = theme === Theme.Dark;
  const nextTheme = isDark ? Theme.Light : Theme.Dark;
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  const ThemeIcon = isDark ? Sun : Moon;

  return (
    <IconButton
      className={classNames(styles.themeToggle, className)}
      aria-label={label}
      aria-pressed={isDark}
      title={label}
      onClick={() => {
        onToggle(nextTheme);
      }}
    >
      <ThemeIcon aria-hidden="true" />
    </IconButton>
  );
};

export default ThemeToggleButton;
